import React, { useState } from "react";
import classNames from "classnames";
import { connect } from "react-redux";
import { Tooltip } from "@material-ui/core";
import { Button } from "react-bootstrap";
import { FaDownload, FaExclamationCircle } from "react-icons/fa";
import {
  ProductImageStacType,
} from "../../../types/product";
import { isInterferometricStackSearchResults } from "../../../helpers/searchResultsHelper";
import Loader from "../Loader";
import { DEFAULT_TOOLTIP_PROPS } from "../../../helpers/tooltipHelper";
import translations from "../../../translations";
import DownLoadSearchResultsModal from "./DownLoadSearchResultsModal";

interface PropsType {
  language: string;
  buttonFilters: any;
  selectedProducts: ProductImageStacType[];
  searchFormValues: any;
  formData:any;
  isButtonVisible: boolean;
}

const DownLoadSearchResultsButton = (props: PropsType) => {
  const {
    language,
    selectedProducts,
    searchFormValues,
    formData,
    isButtonVisible = true
  } = props;
  const [buttonView, setButtonView] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const onClickHandler = () => {
    setIsLoading(true);
    setButtonView(true);
    setIsLoading(false);
  };

  let buttonContext;
  if (isLoading) {
    buttonContext = <Loader spinnerClassName="button-size" />;
  } else {
    let buttonText;
    if (selectedProducts && selectedProducts.length > 0) {
      buttonText = `${translations("downloadResults", language)} (${selectedProducts.length})`
    } else {
      buttonText = translations("downloadResults", language);
    }
    buttonContext = <span>{buttonText}</span>;
  }

  return (
    <>
      <div className={classNames({"d-none": !isButtonVisible})}>
        <Tooltip
          {...DEFAULT_TOOLTIP_PROPS}
          title={translations("downloadResults", language)}
          placement="top"
        >
          <span>
            <Button
              style={{minWidth: "auto"}}
              onClick={onClickHandler}
            >
              {/* {buttonContext} */}
              {/* &nbsp; */}
              <FaDownload
                style={{ backgroundColor: "transparent"}}
                size={13}
              />
            </Button>
          </span>
        </Tooltip>
      </div>
      {buttonView ? (
        <DownLoadSearchResultsModal
          formData={formData}
          searchFormValues={searchFormValues}
          selectedProducts={selectedProducts}
          handleClose={() => {
            setButtonView(false);
          }}
        />
      ) : null}
    </>
  );
};

const mapStateToProps = (state) => ({
  configurations: state.application.configurations,
  formData: state.application.formData,
  lastShape: state.geoMap.lastShape,
  allInterferometricStacks: state.product.allInterferometricStacks,
  isInterferometricStackOrder: isInterferometricStackSearchResults(
    state.product.searchResults
  ),
  appParameters: state.application.appParameters,
  language: state.application.appParameters.language,
});

export default connect(mapStateToProps)(DownLoadSearchResultsButton);
